import declare from "dojo/_base/declare";
import Table from "csi/table/Widget";
import { TABLE_HEIGHT_LARGE } from "csi/constants";

const ComplianceAnalysisLargeTableController = declare(Table, {
	/** 
	 * @override 
	 * Set fixed table height value for table
	 * */
	_getEffectiveTableHeight() {
		return TABLE_HEIGHT_LARGE;
	},
});

export = ComplianceAnalysisLargeTableController;